import { render, staticRenderFns } from "./Accessability.vue?vue&type=template&id=55f9ebdc&"
import script from "./Accessability.vue?vue&type=script&lang=js&"
export * from "./Accessability.vue?vue&type=script&lang=js&"
import style0 from "./Accessability.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports